'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dList from "./java.util.-Abstract-List.js";
var $p;
/** @constructor */
function $c_ju_Collections$$anon$15(o$2) {
  this.JT = null;
  this.JT = o$2;
}
export { $c_ju_Collections$$anon$15 as $c_ju_Collections$$anon$15 };
$p = $c_ju_Collections$$anon$15.prototype = new $j_java$002eutil$002e$002dAbstract$002dList.$h_ju_AbstractList();
$p.constructor = $c_ju_Collections$$anon$15;
/** @constructor */
function $h_ju_Collections$$anon$15() {
}
export { $h_ju_Collections$$anon$15 as $h_ju_Collections$$anon$15 };
$h_ju_Collections$$anon$15.prototype = $p;
$p.T = (function() {
  return 1;
});
$p.fS = (function(index) {
  if ((index === 0)) {
    return this.JT;
  } else {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
var $d_ju_Collections$$anon$15 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Collections$$anon$15, "java.util.Collections$$anon$15", ({
  mU: 1,
  dN: 1,
  bt: 1,
  aU: 1,
  bc: 1,
  bu: 1,
  ck: 1,
  a: 1
}));
export { $d_ju_Collections$$anon$15 as $d_ju_Collections$$anon$15 };
